import { render, staticRenderFns } from "./type2.vue?vue&type=template&id=c80d9a26"
import script from "./type2.vue?vue&type=script&lang=js"
export * from "./type2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c80d9a26')) {
      api.createRecord('c80d9a26', component.options)
    } else {
      api.reload('c80d9a26', component.options)
    }
    module.hot.accept("./type2.vue?vue&type=template&id=c80d9a26", function () {
      api.rerender('c80d9a26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/projectConfig/components/type2.vue"
export default component.exports